import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, memo } from 'react';
const SvgAccountPlus = (props, ref) => (_jsx("svg", Object.assign({}, props, { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: ref }, { children: _jsx("path", { d: "M15 14c-2.67 0-8 1.33-8 4v2h16v-2c0-2.67-5.33-4-8-4m-9-4V7H4v3H1v2h3v3h2v-3h3v-2m6 2a4 4 0 0 0 4-4 4 4 0 0 0-4-4 4 4 0 0 0-4 4 4 4 0 0 0 4 4Z" }, void 0) }), void 0));
const ForwardRef = forwardRef(SvgAccountPlus);
const Memo = memo(ForwardRef);
export default Memo;
//# sourceMappingURL=AccountPlus.js.map